<form [formGroup]="formGroup" enctype="multipart/form-data">
    <div class="form-group">
        <!-- <label for="file">Seleccione el archivo</label> -->
        <input type="file" class="form-control-file d-flex justify-content-center text-center" id="file" formControlName="file" (change)="onFileChange($event)">
        <!-- <button class="btn btn-primary mt-1 mb-1" type="submit">Subir</button> -->
    </div>
</form>